import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PresetsWrapper } from './styles';

const Wrapper: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { t } = useTranslation();
    return <PresetsWrapper>{children}</PresetsWrapper>;
};

export default Wrapper;
